// This is a complete list of all the different gratuity GUIDs across all of the restaurants
export const GRATUITY_GUIDS = [
  '2eec3288-cdc6-4c65-8479-4f8686f2982a',
  '314da5fc-637e-41fa-af0c-a7a097fcb62e',
  '3123fb8b-ca2f-4bfa-8b58-12e42cda3124',
  'e8128466-00dd-40ee-9865-62c4349bd287',
  '99502fc6-6cf0-4ffa-a6e6-c3850e864fc9',
  '0367c1fe-df88-42d4-9361-272c0c09ea7e',
  '0512d9eb-569d-4fec-a1d0-32868f4c09ae',
  '765ac902-92de-4fa9-83df-45fe186df9f0',
  '40b07b00-8af5-416f-b6c0-92e36cb38401',
  '31455d4b-9fab-46e8-bfbe-1640fe381af6',
  '44740a51-5905-4263-b748-b3ee284ad514',
  '78cafea9-45dc-419d-8dc3-1003a12b1dc4',
  'c8f64977-c303-4f84-85e0-b2d8d7dd0e48',
  'dbd9e3b2-16f3-441d-b3cf-08ff9d20e0ac',
  '04448c57-ca9d-4daa-b94d-ecbfd6cc2997',
  '59691323-b6bc-4582-8808-e7e255de3947',
  '424e8b98-6309-4754-a7a6-cf74540da1fb',
  '3706807c-0091-4f6b-b88f-6aa245959653',
  '912b2c18-16f7-4523-949f-9c53ec555df4',
];
